import { publicSiteUrl } from '@web/router/urls';
export var payproCheckout = function (input) {
    return {
        checkoutUrl: "".concat(publicSiteUrl)
    };
};
